import { render, staticRenderFns } from "./order_by_id.vue?vue&type=template&id=2e23c11e&scoped=true&"
import script from "./order_by_id.vue?vue&type=script&lang=js&"
export * from "./order_by_id.vue?vue&type=script&lang=js&"
import style0 from "./order_by_id.vue?vue&type=style&index=0&id=2e23c11e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e23c11e",
  null
  
)

export default component.exports